// extracted by mini-css-extract-plugin
export default {"customBtn":"CustomBtn_customBtn__JfPtH","ripple":"CustomBtn_ripple__Oyywc","ripple-effect":"CustomBtn_ripple-effect__xFTDh","loaderContainer":"CustomBtn_loaderContainer__zz+UR"};